import styled from 'styled-components';
import { min } from '../../lib/responsive';

const WorkshopsOverflow = styled.div`
  overflow: hidden;
`;

const WorkshopsWrapper = styled.div`
  width: 100%;
  @media ${min.mobile} {
    padding-left: 0;
    padding-top: 3rem;
  }
  @media ${min.tabletLg} {
    padding-left: 15rem;
  }
  @media ${min.desktop} {
    padding-left: 35rem;
  }
`;

const WorkshopsImage = styled.img`
  @media ${min.mobile} {
    padding-left: 0;
    width: 100%;
  }

  @media ${min.tablet} {
    width: 50%;
  }

  @media ${min.tabletLg} {
    padding-left: 5rem;
    width: auto;
  }
`;

const Margin = styled.div`
  margin: 0 1rem;
  @media ${min.mobile} {
    margin: 0;
  }
  @media ${min.tablet} {
    margin: 0 5rem;
  }
`;
export { WorkshopsWrapper, WorkshopsImage, Margin, WorkshopsOverflow };
